import { IUserTransaction } from '@/interfaces';
import ButtonLinkUser from '../ButtonLinkUser';
import { ProductsEnum } from '@/enums';

type TProps = {
  transaction: IUserTransaction;
}

export const DataTableBodyCellDetailsSendDm = ({ transaction }: TProps) => {

  if (transaction?.product !== ProductsEnum.SEND_DM) {
    return <></>;
  }

  return (
    <div className='flex items-center space-x-1 text-sm text-nowrap'>
      {
        transaction.options?.dmRecipient &&
        <>
          <span>
            Envoyé à
          </span>
          <ButtonLinkUser userId={transaction.options.dmRecipient} />
        </>
      }
    </div>
  );

};

export default DataTableBodyCellDetailsSendDm;
